export function getFormatSFC (data) {
  if (!data[0]) return ''
  return data.map(entry => {
    const date = new Date(entry.date)
    const formattedDate = date.toLocaleDateString('fr-FR')

    if (!entry.open) {
      return `${formattedDate}:Fermé`
    }

    const times = []
    if (entry.fullHours) {
      times.push('00h00:23h59')
    } else {
      if (entry.ouv1 && entry.fer1) {
        times.push(`${entry.ouv1.replace(':', 'h')}:${entry.fer1.replace(':', 'h')}`)
      }
      if (entry.showTimes2 && entry.ouv2 && entry.fer2) {
        times.push(`${entry.ouv2.replace(':', 'h')}:${entry.fer2.replace(':', 'h')}`)
      }
    }

    return `${formattedDate}:${times.join(':') || 'Fermé'}`
  }).join(';') + ';'// Ajout du point-virgule final obligatoire
}

export function compareAndAddTimeString (existingString, newString) {
  if (typeof existingString !== 'string' || typeof newString !== 'string') {
    return ''
  }
  const cleanExisting = existingString.trim().replace(/;+$/, '')
  const cleanNew = newString.trim().replace(/;+$/, '')
  if (!cleanExisting) {
    return cleanNew
  }
  const existingSegments = cleanExisting.split(';')
  if (existingSegments.includes(cleanNew)) {
    return undefined
  }
  return cleanNew
}
